const isIE11 = () => {
  return !!window.MSInputMethodContext && !!document.documentMode;
};

const resizeImagesIE = () => {
  const allImages = [];
  const columns = document.querySelectorAll('.wp-block-deepsea-column');
  columns.forEach(column => {
    const images = column.querySelectorAll('figure.wp-block-image > img');
    images.forEach(image => {
      allImages.push(image);
    });
  });
  allImages.forEach(image => {
    const srcImageHeight = image.naturalHeight;
    const srcImageWidth = image.naturalWidth;
    const naturalAspectRatio = srcImageWidth / srcImageHeight;

    const proportionalClientHeight = image.clientWidth / naturalAspectRatio;
    /* eslint-disable no-param-reassign */
    image.style.height = `${Math.round(proportionalClientHeight)}px`;
  });
};

if (isIE11()) {
  document.addEventListener('DOMContentLoaded', resizeImagesIE);
  window.addEventListener('resize', resizeImagesIE);
}
